import { ParamsResponse } from 'interfaces/global.types';
import request from './request';

const HomeService = {
  getAll: (params?: ParamsResponse) => request.get('homepage/', { params }),
  getID: (id?: number) => request.get(`homepage/${id}/`),
  delete: (id?: number) => request.delete(`homepage/${id}/`),
  create: (data?: any) => request.post('homepage/', data),
  update: (id?: number, data?: any) => request.patch(`homepage/${id}/`, data),
};

export default HomeService;
